import React, { useState, useRef } from 'react'
import styles from './Phase2.module.css'
import { shuffledArray } from '../../../../../util/util'
import IconVolume from '../../../../../assets/icons/IconVolume'

import {
    getSoundDownloadUrl,
} from '../../components/Sound/Sound'

const Phase2 = ({
    words,
    onNextPhase,
    onProgress,
}) => {

    const shuffledWords = useRef(shuffledArray(words))
    const mediaPlayer = useRef(new Audio())

    const [selectedEnglishWord, setSelectedEnglishWord] = useState(-1)
    const [selectedHebrewWord, setSelectedHebrewWord] = useState(-1)
    const [shuffledEnglishWords, setShuffledEnglishWords] = useState(shuffledArray(shuffledWords.current.slice(0, 4)))
    const [doneEnglishWords, setDoneEnglishWords] = useState(Array(4).fill(false))
    const [doneHebrewWords, setDoneHebrewWords] = useState(Array(4).fill(false))
    const [bad, setBad] = useState(false)
    const [good, setGood] = useState(false)

    const [startIndex, setStartIndex] = useState(0)
    const [endIndex, setEndIndex] = useState(4)
    const [currIndex, setCurrIndex] = useState(0);

    const handleEnglishWordClick = (index) => {
        setSelectedEnglishWord(index)
        if (selectedHebrewWord !== -1) {
            onCheck(selectedHebrewWord, index)
        }
    }

    const handleHebrewWordClick = (index) => {
        getSoundDownloadUrl(shuffledWords.current[index + startIndex].sound_path)
            .then((url) => {
                mediaPlayer.current.pause();
                mediaPlayer.current.src = url;
                mediaPlayer.current.play()
            })
        setSelectedHebrewWord(index)
        if (selectedEnglishWord !== -1) {
            onCheck(index, selectedEnglishWord)
        }
    }

    const onCheck = (hebrewIndex, englishIndex) => {
        if (shuffledWords.current[hebrewIndex + startIndex].vow === shuffledEnglishWords[englishIndex].vow) {
            setGood(true)
            setCurrIndex(index => index + 1)
            onProgress(currIndex + 1)
            setTimeout(() => {
                setSelectedHebrewWord(-1)
                setSelectedEnglishWord(-1)
                setGood(false)
                const updatedDoneEnglishWords = doneEnglishWords.slice();
                updatedDoneEnglishWords[englishIndex] = true;
                setDoneEnglishWords(updatedDoneEnglishWords)
                const updatedDoneHebrewWords = doneHebrewWords.slice();
                updatedDoneHebrewWords[hebrewIndex] = true;
                setDoneHebrewWords(updatedDoneHebrewWords)

                if (updatedDoneHebrewWords.indexOf(false) === -1) {

                    if (endIndex === words.length) {
                        onNextPhase();
                        return;
                    }
                    const newStartIndex = startIndex + (endIndex - startIndex);
                    let newEndIndex = endIndex + 4
                    if (words.length - endIndex === 5) {
                        newEndIndex = endIndex + 3
                    }
                    if (endIndex + 4 > words.length) {
                        newEndIndex = words.length
                    }
                    
                    setStartIndex(newStartIndex)
                    setEndIndex(newEndIndex)
                    setDoneHebrewWords(Array(newEndIndex - newStartIndex).fill(false))
                    setDoneEnglishWords(Array(newEndIndex - newStartIndex).fill(false))
                    setShuffledEnglishWords(shuffledArray(shuffledWords.current.slice(newStartIndex, newEndIndex)))
                }
            }, 500);
        }
        else {
            setBad(true)
            setTimeout(() => {
                setSelectedHebrewWord(-1)
                setSelectedEnglishWord(-1)
                setBad(false)
            }, 500);
        }
    }

    return (
        <div className={styles.container}>
            <div className={styles.hebrewWordsContainer}>
                {shuffledWords.current.slice(startIndex, endIndex).map((word, index) => {
                    return (
                        <div
                            onClick={bad || good || doneHebrewWords[index] ? null : () => handleHebrewWordClick(index)}
                            className={styles.wordContainer}
                            style={{
                                backgroundColor: selectedHebrewWord === index ? good ? '#26C281' : bad ? '#FF6464' : '#309CFF' : 'white',
                                opacity: doneHebrewWords[index] ? 0 : 1,
                                cursor: doneHebrewWords[index] ? 'auto' : 'pointer'
                            }}>
                            <IconVolume size={24} className={styles.wordVolumeIcon} color={selectedHebrewWord === index ? 'white': null}/>
                            <p
                                className={styles.hebrewWord}
                                style={{ color: selectedHebrewWord === index ? 'white' : 'black' }}>{word.vow}</p>
                        </div>
                    )
                })}
            </div>
            <div className={styles.englishWordsContainer}>
                {shuffledEnglishWords.map((word, index) => {
                    return (
                        <div
                            onClick={bad || good || doneEnglishWords[index] ? null : () => handleEnglishWordClick(index)}
                            className={styles.wordContainer}
                            style={{
                                width: '48%',
                                backgroundColor: selectedEnglishWord === index ? good ? '#26C281' : bad ? '#FF6464' : '#309CFF' : 'white',
                                opacity: doneEnglishWords[index] ? 0 : 1,
                                cursor: doneEnglishWords[index] ? 'auto' : 'pointer'
                            }}>
                            <p
                                className={styles.englishWord}
                                style={{ color: selectedEnglishWord === index ? 'white' : 'black' }}>{word.eng}</p>
                        </div>
                    )
                })}
            </div>

        </div>
    )
}

export default Phase2
